var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditNewIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2916 2.4668L4.14993 12.6168L2.5166 17.4918L7.3916 15.8585L17.5416 5.70846L14.2999 2.4668H14.2916ZM15.7666 5.70846L7.2666 14.2085L5.79993 12.7418L14.2999 4.2418L15.7749 5.7168L15.7666 5.70846ZM5.07493 13.7751L6.22493 14.9251L4.4916 15.5085L5.07493 13.7751Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditNewIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Edit_New_Icon.4e505c12191c181132a2fac23b5737bd.svg";